import { render, staticRenderFns } from "./AccountMenu.html?vue&type=template&id=371fb120&scoped=true&"
import script from "./AccountMenu.js?vue&type=script&lang=js&"
export * from "./AccountMenu.js?vue&type=script&lang=js&"
import style0 from "./account-menu.scss?vue&type=style&index=0&id=371fb120&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371fb120",
  null
  
)

export default component.exports